export default __webpack_public_path__ + "static/media/slide-4.3abf1660.png";